import {
  getFlowConfRequest,
  operateFlowconfShowRequest,
  operateCreateFlowconfRequest,
  getFlowConfClassingRequest,
  requestFlowConfClassing
} from '../../../api/api'
import {getUrl} from "../../../utils/global/geturl";  // 导入封装后的axios请求

const state = {}

const getters = {}

const actions = {
  async getFlowConf ({commit}, params) {
    return getFlowConfRequest(getUrl(params)).then(response => response)
  },
  async operateFlowconfShow ({commit}, params) {
    return operateFlowconfShowRequest(getUrl(params)).then(response => response)
  },
  async operateCreateFlowconf ({commit}, params) {
    return operateCreateFlowconfRequest(params).then(response => response)
  },

  async getFlowConfClassing ({commit}, params) {
    return getFlowConfClassingRequest(getUrl(params)).then(response => response)
  },
  async hanleFlowConfClassing ({commit}, params) {
    return requestFlowConfClassing(params).then(response => response)
  },
};

const mutations = {}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/flowconf/flowconf.js